import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./home_page.scss";
import HomePageDesktop from "./home_page_desktop/home_page_desktop";
import HomePageMobile from "./home_page_mobile/home_page_mobile";
import { HOME_CONFIG } from "../../config/home_page_config";
import Helmet from "react-helmet";
import { extraSmallLayout } from "../../utils/device";
import { HIGH_LEVEL_CONFIG } from "../../config/high_level_config";
import { pageLoaded } from "../../utils/utils";
import { API_CONFIG } from "../../config/api_config";
import axios from "axios";

/**
 * The Home page of the luiss.it website.
 * The page renders a full screen grid of contents on desktop and a vertically scrollable list of items on mobile.
 * The Home page is the only page that has a different layout from the template page.
 */
class HomePage extends TemplateComponent {
    constructor(props) {
        super(props);
        // At the beginning the modal is closed and we see the contents grid
        this.state = { desktopCards: [] };
        const navbarColor = extraSmallLayout() ? HOME_CONFIG.NAVBAR_COLOR_MOBILE : HOME_CONFIG.NAVBAR_COLOR_DESKTOP;
        this.props.menuColorCallback(navbarColor);
        this.props.breadcrumbCallback([]);
    }

    componentDidMount() {
        super.componentDidMount();
    }

    onDataLoaded(data) {
        super.onDataLoaded(data);
        this.loadDataFromSecondAPI();
        pageLoaded();
    }

    loadDataFromSecondAPI = async () => {
        const secondURI = `${API_CONFIG.BASE_URL + API_CONFIG.HOME_CONTENTS_PATH2}/${this.props.url?.slice(-2)}`;
        const bannerHpURI = `${API_CONFIG.BASE_URL + API_CONFIG.HOMEPAGE_BANNER}/${this.props.url?.slice(-2)}`;
        this.setState({
            desktopCards: {
                button: this.state.data.button,
                cards: this.state.data.cards
            }
        });
        axios.get(secondURI)
            .then((res) => {
                // console.log("Homepage------",res)
                this.setState({ data: { button: this.state.data.button, cards: this.state.data.cards.concat(res.data.cards) } })
            }
            ).then(
                () => {
                    let temporaryCards = this.state.data.cards.sort((a, b) => {
                        return new Date(b.created) - new Date(a.created);
                    }).slice(0, 12);
                    this.setState({ data: { button: this.state.data.button, cards: temporaryCards } });
                }
            ).catch(error => console.log('### Failed to load secondary data - error: ' + error))



        axios.get(bannerHpURI)
            .then((res) => {
                this.setState({ banner: res.data });
            })



    }


    // region: rendering -----------------------------------------------------------------------------------------------

    render() {
        if (this.props.url.endsWith("/it")) {
            var lang = "it";
        } else {
            lang = "en"
        }
        let homePage;
        // ------- MOBILE version ---------
        if (extraSmallLayout()) {
            homePage = <HomePageMobile {...this.state.data} {...this.state.banner} lang={lang} />;
            // console.log(this.state.data);
        } else {
            // ------- DESKTOP version --------
            homePage = <HomePageDesktop {...this.state.desktopCards} {...this.state.banner} navigate={this.props.history.push} lang={lang} />;
            // console.log(this.state.desktopCards);
        }

        return (
            <>
                <Helmet>
                    <meta property="og:title" content="Luiss Guido Carli" />
                    <meta name="twitter:title" property="twitter:title" content="Luiss Guido Carli" />

                    <meta name="description" content="Entra in LUISS e scopri i corsi di Laurea, i Master e tutti i servizi per gli studenti" />
                    <meta property="og:description" content="Entra in LUISS e scopri i corsi di Laurea, i Master e tutti i servizi per gli studenti" />
                    <meta name="twitter:description" property="twitter:description"
                        content="Entra in LUISS e scopri i corsi di Laurea, i Master e tutti i servizi per gli studenti" />

                    <meta property="og:image" content={HIGH_LEVEL_CONFIG.DEFAULT_IMAGE_URL} />
                    <meta name="twitter:image" property="twitter:image" content={HIGH_LEVEL_CONFIG.DEFAULT_IMAGE_URL} />
                    <meta name="twitter:image:alt" property="twitter:image:alt" content="Luiss Guido Carli" />

                    <meta property="og:url" content="https://www.luiss.it" />

                    <meta property="og:type" content="website" />
                </Helmet>
                {homePage}
            </>
        );
    }
}


export default HomePage;
